import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/logo.png'
import _imports_1 from '@/assets/Frame1.png'
import _imports_2 from '@/assets/Frame2.png'
import _imports_3 from '@/assets/Frame3.png'
import _imports_4 from '@/assets/Frame4.png'
import _imports_5 from '@/assets/bvlv_blue.png'
import _imports_6 from '../../assets/bvlv_zb.png'
import _imports_7 from '@/assets/bvlv_gd.png'
import _imports_8 from '../../assets/grzy_icon.png'
import _imports_9 from '../../assets/zt_zanwushuju.png'
import _imports_10 from '../../assets/module_share_open.png'
import _imports_11 from '../../assets/bvlv_blue.png'
import _imports_12 from '../../assets/LS4.png'


const _hoisted_1 = {
  key: 0,
  style: {"position":"relative","background":"#f5f5f5","display":"block","width":"100%","margin":"0 auto"}
}
const _hoisted_2 = {
  style: {"position":"relative","overflow":"hidden"},
  class: "bg_img"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "body_left" }
const _hoisted_6 = { style: {"position":"relative","top":"-0.4rem"} }
const _hoisted_7 = { class: "body_left_head_avatar" }
const _hoisted_8 = {
  key: 0,
  class: "body_left_img",
  src: _imports_0
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "body_left_userList",
  style: {"z-index":"4"}
}
const _hoisted_11 = {
  key: 3,
  src: _imports_4,
  title: "创作达人"
}
const _hoisted_12 = {
  key: 0,
  class: "wVC_list_l_T_B_rz"
}
const _hoisted_13 = { class: "body_video_left_userMessage" }
const _hoisted_14 = { class: "bvlu_number" }
const _hoisted_15 = { class: "bvlu_number" }
const _hoisted_16 = { class: "bvlu_number" }
const _hoisted_17 = { class: "body_video_left_message_title" }
const _hoisted_18 = { class: "body_video_left_location" }
const _hoisted_19 = { class: "body_video_left_visit" }
const _hoisted_20 = { class: "bvlv_imgList" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "bvlv_imgList_title" }
const _hoisted_24 = { class: "bvlv_imgList_time" }
const _hoisted_25 = {
  key: 0,
  class: "cur"
}
const _hoisted_26 = {
  class: "body_right",
  style: {"width":"calc(100% - 3.02rem)","margin-left":"0.24rem"}
}
const _hoisted_27 = { class: "body_right_topList" }
const _hoisted_28 = { style: {"display":"flex","justify-content":"left","z-index":"5"} }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { style: {"color":"#fff"} }
const _hoisted_31 = { style: {"padding-left":"0.24rem","height":"100%"} }
const _hoisted_32 = {
  key: 0,
  class: "br_div"
}
const _hoisted_33 = {
  class: "brt_list top_click_list",
  style: {"margin-bottom":"0.2rem"}
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { style: {"width":"100%"} }
const _hoisted_36 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_37 = {
  key: 1,
  class: "br_div"
}
const _hoisted_38 = { class: "top_click_list" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  style: {"watch":"100%"}
}
const _hoisted_41 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_42 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_43 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_44 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_45 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_46 = {
  key: 2,
  class: "br_div"
}
const _hoisted_47 = {
  class: "top_click_list",
  style: {}
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_50 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_51 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_52 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_53 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_54 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_55 = {
  key: 3,
  style: {"width":"100%"}
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  class: "zwsj",
  src: _imports_9
}
const _hoisted_58 = {
  key: 4,
  style: {"width":"100%"}
}
const _hoisted_59 = { style: {"display":"flex","flex":"1","flex-wrap":"wrap","row-gap":"10px","column-gap":"20px"} }
const _hoisted_60 = { style: {"position":"absolute","bottom":"-0.2rem","width":"100%"} }
const _hoisted_61 = {
  key: 0,
  class: "accessListPopup"
}
const _hoisted_62 = { class: "aLP_center" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "wVC_list_l" }
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "wVC_list_l_Title" }
const _hoisted_67 = { class: "wVC_list_l_T_T" }
const _hoisted_68 = { class: "wVC_list_l_T_T_name" }
const _hoisted_69 = { class: "wVC_list_l_T_T_time" }
const _hoisted_70 = { class: "wVC_list_l_T_B" }
const _hoisted_71 = { class: "wVC_list_l_T_B_location" }
const _hoisted_72 = { class: "wVC_list_r" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { style: {"width":"100%"} }
const _hoisted_75 = { style: {"position":"relative","height":"1.46rem","width":"100%"} }
const _hoisted_76 = {
  key: 0,
  style: {"width":"100%","height":"1.46rem","object-fit":"cover"},
  src: _imports_12
}
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "yinyue" }

import { ref, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
// 关注
import moduleSEProvideMaterial from "../../components/moduleSEProvideMaterial.vue";
import Follow from "@/components/Composer/Follow.vue";
// 粉丝
import Vermicelli from "@/components/Composer/Vermicelli.vue";

// import SCHWorks from "../../views/ShadowUser/SCH_works.vue"
import moduleUserWorks from "../../components/moduleUserWorks.vue";
import moduleShare from "../../components/moduleShare.vue";
// 可编辑
import moduleUserProvideMaterial from "../../components/moduleUserProvideMaterial.vue";
import moduleUserProvideMusic from "../../components/moduleUserProvideMusic.vue";
import moduleUserProvideImage from "../../components/moduleUserProvideImage.vue";
//展示的
import moduleProvideMaterial from "../../components/sc_moduleProvideMaterial.vue";
// import moduleProvideMaterial from "../../components/sc_moduleProvideMaterial.vue";
import moduleProvideMaterialMusic from "../../components/sc_moduleProvideMaterialMusic.vue";
import moduleProvideMaterialImage from "../../components/sc_moduleProvideMaterialImage.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import DetailsOfWorks from "./components/DetailsOfWorks.vue";
import { ElMessage } from "element-plus";
import { WaterFall } from "./WaterFall.js"
import { ElLoading } from "element-plus";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { log } from "console";
const loading = null;

export default /*@__PURE__*/_defineComponent({
  __name: 'ShadowUser',
  setup(__props) {

document.title = "标识山西-登陆人详情";
let pageDef = ref({
  pageNum: 1,
  pageSize: 9,
  total: 0,
});
const DetailsOfWorksRef = ref();
const FollowRef = ref();
const VermicelliRef = ref();
const page = pageDef;
const router = useRouter();
let sc_type = ref(0);
let SC_VIDEO_LIST = ref([]);
let SC_MUSIC_LIST = ref([]);
let SC_IMAGE_LIST = ref([]);
let totalSUCAI_video = ref(0);
let totalSUCAI_value = ref(1);
let pageNum = ref(1); // 总页数
let pageSize = ref(6); // 数量/页
let VIDEOnumber = ref(0);
let topList_scType = ref("VIDEO");
let user = ref(localStorage.getItem("userList") || null);
let userList = ref({
  // backImage : '' ,
  // enterpriseStatus: 2 ,
  // niceName : '',
  // signingNumer: 0  ,
  // fansNumber: 0 ,
  // followNumber: 1 ,
});
const FollowClick = () => {
  FollowRef.value.init(JSON.parse(localStorage.getItem("userList")).memberId);
};
const VermicelliClick = () => {
  VermicelliRef.value.init(
    JSON.parse(localStorage.getItem("userList")).memberId
  );
};
const DetailsOfWorksClick = (item) => {
  DetailsOfWorksRef.value.init(item.id);
};
const getInfo = async () => {
  Axios("GET", "/member/login-info/", false, false, function (res) {
    userList.value = res.data.data;
  });
};
getInfo();
const CloseQrCode1 = () => {
  console.log(12121);
  getInfo();
  deleteFunSucai();
  getListZUOPING();
  getBrowse();
};
const CloseQrCode = () => {
  console.log("关闭");
};
// 右侧 - 作品
let ru_zuoping = ref([
  {
    title: "默认",
    checked: true,
    number: 0,
  },
  {
    title: "最新作品",
    checked: false,
    number: 0,
  },
  {
    title: "热门作品",
    checked: false,
    number: 0,
  },
]);
let ru_zp_click = function (index) {
  for (let i = 0; i < ru_zuoping.value.length; i++) {
    if (ru_zuoping.value[i] == index) {
      ru_zuoping.value[i].checked = true;
      page.value.pageNum = 1;
      getListZUOPING(i);
    } else {
      ru_zuoping.value[i].checked = false;
    }
  }
};
const right_urlList = ref([
  {
    title: "案例",
    number: 0,
    checked: true,
    type: "zuoping",
  },
  {
    title: "素材",
    number: 0,
    checked: false,
    type: "sucai",
  },
  {
    title: "收藏",
    number: 0,
    // number: (sc_sucai_music.length + sc_sucai_video.length + sc_sucai_image.length) || 0,

    checked: false,
    type: "soucang",
  },
]);
let rwm = ref("");
let right_urlListNumber = ref(0);
const deleteFunSucai = function () {
  let getUserList = {
    materialType: topList_scType.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    status: 0,
    orderByColumn: "createTime",
    isAsc: "desc",
  };
  Axios("GET", "/fodder/manage/my-list", getUserList, false, function (res) {
    if (topList_scType.value == "VIDEO") {
      SC_VIDEO_LIST.value = [];
      SC_VIDEO_LIST.value = res.data.rows;
    }
    if (topList_scType.value == "IMAGE") {
      SC_IMAGE_LIST.value = [];
      SC_IMAGE_LIST.value = res.data.rows;
    }
    if (topList_scType.value == "MUSIC") {
      SC_MUSIC_LIST.value = [];
      SC_MUSIC_LIST.value = res.data.rows;
    }
  });
  Axios(
    "GET",
    "/fodder/manage/my-count",
    {
      isMy: true,
    },
    false,
    function (res) {
      console.log(res);
      if (res.data.data) {
        topList_sc.value[0].number = res.data.data.videoCount;
        topList_sc.value[1].number = res.data.data.musicCount;
        topList_sc.value[2].number = res.data.data.imageCount;
        totalSUCAI_video.value = res.data.data.videoCount;
        VIDEOnumber.value =
          topList_sc.value[0].number +
          topList_sc.value[1].number +
          topList_sc.value[2].number;
        right_urlList.value[1].number = VIDEOnumber.value;
      }
    }
  );
};
deleteFunSucai();
const brtListClick = function (index) {
  for (let i = 0; i < right_urlList.value.length; i++) {
    if (i == index) {
      right_urlList.value[i].checked = true;
      /* 调用作品接口 */
      right_urlListNumber.value = i;
      page.value.pageNum = 1;
      page.value.total = 1;
      if (right_urlList.value[i].type == "zuoping") {
        ru_zuoping.value.forEach((e) => (e.checked = false));
        ru_zuoping.value[0].checked = true;
        getListZUOPING(0);
      }
      /* 调用素材接口 */
      if (right_urlList.value[i].type == "sucai") {
        topList_sc.value.forEach((e) => (e.checked = false));
        topList_sc.value[0].checked = true;
        topList_scType.value = "VIDEO";
        let getUserList = {
          materialType: topList_scType.value, // 视频,音乐,图片的类型判断
          // pageNum: page.value.pageNum,
          pageSize: page.value.pageSize,
          status: 0,
          orderByColumn: "createTime",
          isAsc: "desc",
        };
        Axios(
          "GET",
          "/fodder/manage/my-list",
          getUserList,
          false,
          function (res) {
            SC_VIDEO_LIST.value = [];
            SC_VIDEO_LIST.value = res.data.rows;
            // page.value.pageNum = res.data.pages //总页数
            page.value.total = res.data.total;
          }
        );
      }
      if (right_urlList.value[i].type == "soucang") {
        // console.log("收藏");
        topListClick_shouc(0);
      }
    } else {
      right_urlList.value[i].checked = false;
    }
  }
};
const SC_VIDEO_LIST1 = ref([]);
let getUserList = {
  // pageNum: page.value.pageNum,
  pageSize: page.value.pageSize,
  pageIndex: page.value.pageNum,
  // status: 0,
};

const getListZUOPING = function (index = 0) {
  getUserList.pageIndex = page.value.pageNum;
  index == 0 ? delete getUserList.sort : "";
  index == 1 ? (getUserList.sort = "id") : "";
  index == 2 ? (getUserList.sort = "plays") : "";
  console.log(getUserList);

  // loading = ElLoading.service({
  //   lock: true,
  //   text: "Loading",
  //   background: "rgba(0, 0, 0, 0.7)",
  // });
  Axios(
    "post",
    "/material/material/work/my",
    getUserList,
    false,
    function (res) {
      SC_VIDEO_LIST1.value = [];
      SC_VIDEO_LIST1.value = res.data.data.records;
      // page.value.pageNum = res.data.pages //总页数
      page.value.total = res.data.data.total;
      right_urlList.value[0].number = res.data.data.total;
      ru_zuoping.value[0].number = res.data.data.total;
      ru_zuoping.value[1].number = res.data.data.total;
      ru_zuoping.value[2].number = res.data.data.total;
      console.log(" page.value.total", page.value.total);
      // loading.close();
    }
  );
};
getListZUOPING();
const nav_url = ref("/SCH_works");
const urlNumber = ref[0];
const windowVisitChildren = ref(false);
// const bodyStyle = document.body.style;
const windowVisit = function () {
  windowVisitChildren.value = true;
  // bodyStyle.overflowY = "hidden";
};
const openWindow = function () {
  windowVisitChildren.value = false;
  // bodyStyle.overflowY = "auto";
};
/* 默认 */
// bodyStyle.overflowY = 'hidden';
let shareChecked = ref(false);
const ParticularsOverYse = function (index) {
  rwm.value = index;
  shareChecked.value = true;
  // bodyStyle.overflowY = "hidden";
};
/* 删除刷新 */
const deleteFun = function (id) { };
const ParticularsOverNo = function () {
  shareChecked.value = false;
  // bodyStyle.overflowY = "auto";
};

// const topList_zp = ref([
//   {
//     title: "默认",
//     checked: true,
//   },
//   {
//     title: "最多签单",
//     checked: false,
//   },
//   {
//     title: "最多好评",
//     checked: false,
//   },
// ]);
const topList_sc = ref([
  {
    title: "视频素材",
    checked: true,
    type: "VIDEO",
    number: "",
  },
  {
    title: "音乐素材",
    checked: false,
    type: "MUSIC",
    number: "",
  },
  {
    title: "图片素材",
    checked: false,
    type: "IMAGE",
    number: "",
  },
]);
let topList_scNumber = ref();
const topList_shouc = ref([
  {
    title: "收藏案例",
    checked: true,
    type: "zp",
    number: "",
  },
  {
    title: "收藏视频",
    checked: false,
    type: "VIDEO",
    number: "",
  },
  {
    title: "收藏音乐",
    checked: false,
    type: "MUSIC",
    number: "",
  },
  {
    title: "收藏图片",
    checked: false,
    type: "IMAGE",
    number: "",
  }, {
    title: "收藏课程",
    checked: false,
    type: "course",
    number: "",
  },
]);
// 作品高亮点击事件
// const topListClick_zp = function (index) {
//   for (let i = 0; i < topList_zp.value.length; i++) {
//     if (topList_zp.value[i] == index) {
//       topList_zp.value[i].checked = true;
//     } else {
//       topList_zp.value[i].checked = false;
//     }
//   }
// };
// 获取素材列表的公共接口 素材高亮点击事件
const topListClick_sc = function (index) {
  for (let i = 0; i < topList_sc.value.length; i++) {
    if (topList_sc.value[i] == index) {
      topList_sc.value[i].checked = true;
      topList_scType.value = topList_sc.value[i].type;
      let getUserList = {
        materialType: topList_sc.value[i].type,
        // pageNum: page.value.pageNum,
        pageSize: page.value.pageSize,
        status: 0,
        orderByColumn: "createTime",
        isAsc: "desc",
      };
      topList_scType.value = topList_sc.value[i].type;

      Axios(
        "GET",
        "/fodder/manage/my-list",
        getUserList,
        false,
        function (res) {
          page.value.total = res.data.total;
          topList_scNumber.value = i;
          if (i == 0) {
            SC_VIDEO_LIST.value = res.data.rows;
          }
          if (i == 1) {
            SC_MUSIC_LIST.value = res.data.rows;
          }
          if (i == 2) {
            SC_IMAGE_LIST.value = res.data.rows;
          }
        }
      );
      // if (i == 1) {
      // 	Axios('GET', '/fodder/manage/my-list', getUserList, false, function(res) {
      // 		page.value.total = res.data.total;
      // 		SC_MUSIC_LIST.value = res.data.rows
      // 		topList_scNumber.value = i

      // 	})

      // }
      // if (i == 2) {
      // 	Axios('GET', '/fodder/manage/my-list', getUserList, false, function(res) {
      // 		page.value.total = res.data.total;
      // 		SC_IMAGE_LIST.value = res.data.rows
      // 		topList_scNumber.value = i
      // 	})

      // }
    } else {
      topList_sc.value[i].checked = false;
    }
  }
};
//素材的公共分页功能
const topListClick_scNymber = function () {
  console.log(page.value);
  let materialType = "";
  for (let i = 0; i < topList_sc.value.length; i++) {
    if (topList_sc.value[i].checked == true) {
      materialType = topList_sc.value[i].type;
    }
  }
  let getUserList = {
    materialType: materialType,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    status: 0,
    orderByColumn: "createTime",
    isAsc: "desc",
  };
  Axios("GET", "/fodder/manage/my-list", getUserList, false, function (res) {
    page.value.total = res.data.total;
    pageNum.value = res.data.pages; //总页数
    if (getUserList.materialType == "VIDEO") {
      SC_VIDEO_LIST.value = [];
      SC_VIDEO_LIST.value = res.data.rows;
    }
    if (getUserList.materialType == "IMAGE") {
      SC_IMAGE_LIST.value = [];
      SC_IMAGE_LIST.value = res.data.rows;
    }
    if (getUserList.materialType == "MUSIC") {
      SC_MUSIC_LIST.value = [];
      SC_MUSIC_LIST.value = res.data.rows;
    }
  });
};
const listData = ref([]);
const collectList = () => {
  Axios(
    "get",
    "/system/courseWeb/collectList",
    Object.assign({
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
    }),
    false,
    (res) => {
      if (res.data.code == 200) {
        listData.value = res.data.rows;
        page.value.total = res.data.total;
        topList_shouc.value[4].number = res.data.total;
      }

    }, () => {
      listData.value = [];
      page.value.total = 0;
      topList_shouc.value[4].number = '0';
    })
}
//收藏切换
const topListClick_shouc = function (index) {
  for (let i = 0; i < topList_shouc.value.length; i++) {
    if (i === index) {
      topList_shouc.value[i].checked = true;
      console.log(i);
      if (i === 0) {
        // 收藏的作品列表接口
        get_soucang_sucai_list1();
        console.log("作品");
      } else if (i >= 1 && i <= 3) {
        get_soucang_sucai_list(topList_shouc.value[i].type);
      } else if (i == 4) {
        page.value.pageNum = 1;
        page.value.pageSize = 6;
        collectList()
      }
    } else {
      topList_shouc.value[i].checked = false;
    }
  }
};
/* 获取数量 */
const getNum = () => {
  for (let i = 0; i < topList_sc.value.length; i++) {
    if (topList_sc.value[i].type == topList_scType.value) {
      topList_sc.value[i].checked = true;
      Axios(
        "GET",
        "/fodder/manage/my-count",
        {
          isMy: true,
        },
        false,
        function (res) {
          if (res.data.data) {
            topList_sc.value[0].number = res.data.data.videoCount;
            topList_sc.value[1].number = res.data.data.musicCount;
            topList_sc.value[2].number = res.data.data.imageCount;
            totalSUCAI_video.value = res.data.data.videoCount;
          }
        }
      );
    }
  }
  Axios(
    "GET",
    `/fodder/collect/my-count/${JSON.parse(localStorage.getItem("userList")).memberId
    }`,
    false,
    false,
    function (res) {
      if (res.data.data) {
        topList_shouc.value[1].number = res.data.data.videoCount;
        topList_shouc.value[2].number = res.data.data.musicCount;
        topList_shouc.value[3].number = res.data.data.imageCount;
        get_soucang_sucai_list1(true);
      } else {
        topList_shouc.value[1].number = 0;
        topList_shouc.value[2].number = 0;
        topList_shouc.value[3].number = 0;
        get_soucang_sucai_list1(true);
      }
    }
  );
  collectList()
};
getNum();
watch(
  () => router.currentRoute.value.path,
  async (params) => {
    if (router.currentRoute.value.path === "/ShadowUser") {
      console.log('Current route is "/ShadowUser"');
      // 执行其他操作
      await nextTick();
      getNum();
      if (router.currentRoute.value.query.type) {
        brtListClick(2);
        right_urlListNumber.value = 2;
      } else {
        brtListClick(0);
        right_urlListNumber.value = 0;
      }
    }
  },
  { immediate: true }
);
// const tg_video = function(index) {
// 	router.push({
// 		path: '/ShadowMaterialVideoParticulars',
// 		query: {
// 			id: index.id
// 		}
// 	})
// }
// 封面
const modifyCover = ref(false);
// 获取收藏的素材列表
let sc_sucai_video = ref([]);
let sc_sucai_video1 = ref([]);
let sc_sucai_music = ref([]);
let sc_sucai_image: any = ref([]);

let get_soucang_sucai_list = function (type) {
  Axios(
    "get",
    "/fodder/collect/list",
    {
      memberId: JSON.parse(localStorage.getItem("userList")).memberId,
      materialType: type,
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
    },
    false,
    function (res) {
      if (type == "MUSIC") {
        sc_sucai_music.value = res.data.rows;
      }
      if (type == "VIDEO") {
        sc_sucai_video.value = res.data.rows;
      }

      if (type == "IMAGE") {
        sc_sucai_image.value = res.data.rows;
        nextTick(() => {
          let mwf = new WaterFall({
            id: 'forcenter',
            imgUrls: res.data.rows.map((item: any) => item.showImage),
          });
          mwf.WFRender()
        });
      }

      page.value.total = res.data.total;
    }
    // function (res) {
    //   console.log(res);
    // }
  );
};
let get_soucang_sucai_list1 = function (type) {
  Axios(
    "post",
    "/material/material/work/favoriteWork",
    {
      pageIndex: page.value.pageNum,
      pageSize: page.value.pageSize,
      condition: {
        userId: JSON.parse(localStorage.getItem("userList")).memberId,
      },
    },
    false,
    function (res) {
      sc_sucai_video1.value = res.data.data.records;
      if (type) {
      } else {
        page.value.total = res.data.data.total;
      }
      topList_shouc.value[0].number = res.data.data.total;
      right_urlList.value[2].number =
        topList_shouc.value[0].number +
        topList_shouc.value[1].number +
        topList_shouc.value[2].number +
        topList_shouc.value[3].number;
    }
  );
};

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 * right_urlListNumber  0 作品 , 1 素材 , 2收藏
 */
const sizeChange = (val) => {
  switch (right_urlListNumber.value) {
    case 0:
      ru_zuoping.value.forEach((e, index) => {
        if (e.checked) {
          getListZUOPING(index);
        }
      });
      break;
    case 1:
      topListClick_scNymber();
      break;
    case 2:
      topList_shouc.value.forEach((e, index) => {
        console.log("checked", e.checked);

        // if (e.checked) {
        //   topListClick_shouc(index);
        // }
      });
      break;
    default:
      // 默认情况下的处理逻辑
      break;
  }
};
const currentChange = (val) => {
  switch (right_urlListNumber.value) {
    case 0:
      ru_zuoping.value.forEach((e, index) => {
        if (e.checked) {
          getListZUOPING(index);
        }
      });
      break;
    case 1:
      topListClick_scNymber();
      break;
    case 2:
      topList_shouc.value.forEach((e, index) => {
        if (e.checked) {
          topListClick_shouc(index);
        }
      });
      break;
    default:
      // 默认情况下的处理逻辑
      break;
  }
};
const prevClick = (val) => {
  switch (right_urlListNumber.value) {
    case 0:
      ru_zuoping.value.forEach((e, index) => {
        if (e.checked) {
          getListZUOPING(index);
        }
      });
      break;
    case 1:
      topListClick_scNymber();
      break;
    case 2:
      topList_shouc.value.forEach((e, index) => {
        console.log("checked", e.checked);

        // if (e.checked) {
        //   topListClick_shouc(index);
        // }
      });
      break;
    default:
      // 默认情况下的处理逻辑
      break;
  }
};
const nextClick = (val) => {
  switch (right_urlListNumber.value) {
    case 0:
      ru_zuoping.value.forEach((e, index) => {
        if (e.checked) {
          getListZUOPING(index);
        }
      });
      break;
    case 1:
      topListClick_scNymber();
      break;
    case 2:
      topList_shouc.value.forEach((e, index) => {
        console.log("checked", e.checked);

        // if (e.checked) {
        //   topListClick_shouc(index);
        // }
      });
      break;
    default:
      // 默认情况下的处理逻辑
      break;
  }
};
/**
 * upload_showImage上传路径
 *上传背景图
 */
const upload_showImage = ref(serverBaseUrl + "/file/upload");
// 允许的文件类型
const allowedExtensions = [".png", ".jpg", ".jpeg"];
// 图片URL
const imageUrl = ref("");
// 上传引用
const upload = ref<any>();

// 上传处理函数
const handleChange = (file: File, fileList: Array<File>) => {
  const extension = file.name.slice(file.name.lastIndexOf("."));

  if (!allowedExtensions.includes(extension.toLocaleLowerCase())) {
    const index = fileList.indexOf(file);
    // 移除非法的文件
    fileList.splice(index, 1);
    // upload.value.handleRemove(file, index);
    // 如果有额外的上传组件的移除方法，写在这里
    return ElMessage.warning("格式不正确");
  }
};

// 上传成功的处理函数
const onSuccessImages = (file) => {
  console.log("file", file);
  imageUrl.value = file.data.url;
};

// 在必要的地方删除了图片
const handleRemove = (file: File, fileList: Array<File>) => {
  const index = fileList.indexOf(file);
  fileList.splice(index, 1);
  imageUrl.value = null;
};
const submitSaverBg = () => {
  console.log(imageUrl.value);
  // console.log(imageUrl, "上传图片后台返回的路径");
  // ElMessage({
  //   message: "开发中。。。",
  //   type: "success",
  // });
  // 1、点击保存执行后台，将imageUrl和其它数据一起传给后台保存。
  //2、保存成功后   modifyCover.value = false;关闭背景上传弹窗，并刷新数据更新背景图片
  Axios(
    "get",
    `/member/setting-back`,
    { path: imageUrl.value },
    false,
    function (res) {
      console.log("=================", res);
      modifyCover.value = false;
      ElMessage.success("上传成功");
      getInfo();
    }
  );
};
// 上传头像
const imageHeadUrl = ref("");
const onSuccessAvatarImages = (res) => {
  // if (res.code == 200) {
  //   //调后台接口
  //   //接口成功后赋值显示
  //   imageHeadUrl.value = res.data.url;
  // //   ElMessage({
  // //     message: "上传成功",
  // //     type: "success",
  // //   });
  // // } else {
  // //   ElMessage({
  // //     message: "上传失败",
  // //     type: "error",
  // //   });
  // }
};
// 获取浏览者记录
let wVC_list = ref([]);
let getBrowse = function (index) {
  let memberId = JSON.parse(localStorage.getItem("userList")).memberId;
  let params = {
    visitedId: memberId,
    pageNum: "",
    pageSize: "",
  };
  // index true 是获取弹窗数据 , false 获取默认数据

  if (index) {
    params.pageNum = 1;
    params.pageSize = 5;
  } else {
    params.pageNum = 1;
    params.pageSize = 30;
  }
  Axios("GET", "/member/member-visited/list", params, false, function (res) {
    // page2.value.total = res.data.total;
    // page1.value.total = res.data.total;
    let datas = res.data.rows;
    let DQ_date = new Date().valueOf();

    function computeTimeTitle(data) {
      let timer = new Date(data.visiteTime).valueOf();
      let zfc = DQ_date - timer;
      let f = 60; // 1分钟
      let s = 60 * 60; // 1小时
      let t = 60 * 60 * 24; // 一天

      if (zfc > t) {
        return (
          new Date(data.visiteTime).getMonth() +
          1 +
          "月" +
          new Date(data.visiteTime).getDate() +
          "日"
        );
      } else if (s < zfc && zfc < t) {
        let xiaoshi = Math.floor((DQ_date - timer) / s);
        let fengzhong = Math.floor(((DQ_date - timer) % s) / f);
        return xiaoshi + "小时" + fengzhong + "分钟";
      } else if (60 < zfc && zfc < s) {
        let fengzhong = Math.floor((DQ_date - timer) / f);
        return fengzhong + "分钟前";
      } else if (zfc < 60) {
        return "刚刚";
      }
    }

    for (let i = 0; i < datas.length; i++) {
      datas[i]["timeTitle"] = computeTimeTitle(datas[i]);
    }

    datas.sort((a, b) => new Date(b.visiteTime) - new Date(a.visiteTime));

    wVC_list.value = datas;
  });
};
getBrowse();
// 跳转他人主页
const composer = function (index) {
  // console.log("index", index);
  // return;
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: index.memberId },
  });
};

const CertificationCenter = (item) => {
  router.push({
    path: "/AuthenTicationHome",
  });
};

// 签单跳转需求管理
const skip = () => {
  router.push({
    path: "requirementManagement",
    query: {
      state: "four",
    },
  });
};
const collectIds = ref([]);
const getCollects = async () => {
  await Axios("get", "/fodder/collect/collect-ids", {}, false, (res) => {
    collectIds.value = res.data.data;
  });
};
getCollects();

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ShadowMaterialyinyue = _resolveComponent("ShadowMaterialyinyue")!

  return (_unref(userList) !== {})
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            style: {"width":"100vw"},
            src: _unref(userList).backImage
        ? _unref(userList).backImage
        : require('../../assets/LS4.png')
        
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (!_unref(userList).avatar)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "body_left_img",
                      style: {"object-fit":"cover","height":"0.8rem"},
                      src: _unref(userList).avatar
                    }, null, 8, _hoisted_9))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(userList).nickName), 1),
                (_unref(userList).realStatus == 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_1,
                      title: "实名认证",
                      onClick: CertificationCenter
                    }))
                  : _createCommentVNode("", true),
                (_unref(userList).enterpriseStatus == 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_2,
                      title: "企业认证",
                      onClick: CertificationCenter
                    }))
                  : _createCommentVNode("", true),
                (_unref(userList).unionStatus == 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: _imports_3,
                      title: "联盟认证",
                      onClick: CertificationCenter
                    }))
                  : _createCommentVNode("", true),
                (_unref(userList).daFlag == 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                style: {"display":"flex","justify-content":"center","padding":"0.18rem 0"},
                onClick: CertificationCenter
              }, [
                (_unref(userList).professionalStatus == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("img", { src: _imports_5 }, null, -1)),
                      _createTextVNode(" 标识山西认证" + _toDisplayString(_unref(userList).profess), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (VermicelliClick()))
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(userList).fansNumber / 1 > 0 ? _unref(userList).fansNumber : 0), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bvlu_title" }, "粉丝", -1))
                ]),
                _createElementVNode("div", {
                  style: {"border-left":"0.01rem solid #e5e6eb","border-right":"0.01rem solid #e5e6eb","cursor":"pointer"},
                  onClick: skip
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(userList).signingNumer / 1 > 0 ? _unref(userList).signingNumer : 0), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bvlu_title" }, "签单", -1))
                ]),
                _createElementVNode("div", { onClick: FollowClick }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(userList).followNumber / 1 > 0 ? _unref(userList).followNumber : 0), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bvlu_title" }, "关注", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(userList).remark), 1),
              _createElementVNode("div", _hoisted_18, [
                _cache[10] || (_cache[10] = _createElementVNode("img", {
                  src: _imports_6,
                  style: {"margin-right":"2px","width":"0.16rem","height":"0.16rem"},
                  alt: "",
                  srcset: ""
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(userList).realPAddress && _unref(userList).realDAddress
              ? _unref(userList).realPAddress + "-" + _unref(userList).realDAddress
              : "暂无具体地址"), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bvlv_title" }, "最近访问", -1)),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wVC_list).slice(0, 5), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "cur",
                      key: index,
                      onClick: ($event: any) => (composer(item))
                    }, [
                      _createElementVNode("img", {
                        style: {"width":"0.5rem","height":"0.5rem","border-radius":"50%"},
                        src: item.avatar ? item.avatar : require('@/assets/logo.png')
                  
                      }, null, 8, _hoisted_22),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(item.memberName), 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(item.timeTitle), 1)
                    ], 8, _hoisted_21))
                  }), 128)),
                  (_unref(wVC_list).length > 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("img", {
                          onClick: windowVisit,
                          src: _imports_7,
                          style: {"width":"0.5rem","height":"0.5rem","border-radius":"50%"}
                        }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "bvlv_imgList_title" }, "更多", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "bvlv_imgList_time" }, " ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(right_urlList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(item.checked == true
              ? 'body_right_topList_t cur'
              : 'body_right_topList_f cur'
              ),
                    onClick: ($event: any) => (brtListClick(index))
                  }, [
                    _createTextVNode(_toDisplayString(item.title) + " ", 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.number), 1)
                  ], 10, _hoisted_29))
                }), 128))
              ]),
              _createElementVNode("span", {
                class: "ghbj",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (modifyCover.value = true))
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("img", { src: _imports_8 }, null, -1),
                _createTextVNode(" 更换背景 ")
              ]))
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_unref(right_urlListNumber) == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ru_zuoping), (index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          onClick: ($event: any) => (_unref(ru_zp_click)(index)),
                          class: _normalizeClass(index.checked == true
                ? 'top_click_listT cur'
                : 'top_click_listF cur'
                )
                        }, _toDisplayString(index.title) + " " + _toDisplayString(index.number), 11, _hoisted_34))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (SC_VIDEO_LIST1.value.length)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SC_VIDEO_LIST1.value, (index) => {
                                return (_openBlock(), _createBlock(_component_el_col, {
                                  span: 8,
                                  key: index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(moduleUserWorks, {
                                      onParticularsOverYse: ParticularsOverYse,
                                      class: "SL_CB_list cur",
                                      item: index,
                                      CloseQrCode1: CloseQrCode1
                                    }, null, 8, ["item"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("img", _hoisted_36))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(right_urlListNumber) == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topList_sc.value, (index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(index.checked == true
                ? 'top_click_listT cur'
                : 'top_click_listF cur'
                ),
                          onClick: ($event: any) => (topListClick_sc(index))
                        }, _toDisplayString(index.title + " " + index.number), 11, _hoisted_39))
                      }), 128))
                    ]),
                    (_unref(topList_scType) == 'VIDEO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          (_unref(SC_VIDEO_LIST) != '')
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SC_VIDEO_LIST), (index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 8,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(moduleUserProvideMaterial, {
                                          class: "cur",
                                          message: index,
                                          onParticularsOverYse: ParticularsOverYse,
                                          onDeleteFunSucai: deleteFunSucai,
                                          style: {"border-radius":"0.12rem"}
                                        }, null, 8, ["message"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_41))
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(topList_scType) == 'MUSIC')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_unref(SC_MUSIC_LIST).length)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SC_MUSIC_LIST), (index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 12,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(moduleUserProvideMusic, {
                                          class: "cur",
                                          onDeleteFunSucai: deleteFunSucai,
                                          key: index,
                                          message: index
                                        }, null, 8, ["message"]))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_43))
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(topList_scType) == 'IMAGE')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (_unref(SC_IMAGE_LIST).length)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SC_IMAGE_LIST), (index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 8,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(moduleUserProvideImage, {
                                          class: "cur",
                                          onDeleteFunSucai: deleteFunSucai,
                                          message: index
                                        }, null, 8, ["message"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_45))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(right_urlListNumber) == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topList_shouc.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(item.checked == true
                ? 'top_click_listT cur'
                : 'top_click_listF cur'
                ),
                          onClick: ($event: any) => (topListClick_shouc(index))
                        }, _toDisplayString(item.title + " " + item.number), 11, _hoisted_48))
                      }), 128))
                    ]),
                    (topList_shouc.value[0].checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (_unref(sc_sucai_video1).length)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sc_sucai_video1), (index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 8,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(moduleUserWorks, {
                                          onParticularsOverYse: ParticularsOverYse,
                                          class: "SL_CB_list cur",
                                          item: index,
                                          CloseQrCode1: CloseQrCode1
                                        }, null, 8, ["item"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_50))
                        ]))
                      : _createCommentVNode("", true),
                    (topList_shouc.value[1].checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          (_unref(sc_sucai_video).length)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sc_sucai_video), (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 8,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(moduleProvideMaterial, {
                                          collectIds: collectIds.value,
                                          class: "cur",
                                          style: {"margin-bottom":"0.1rem","height":"calc(100% - 1.2px)"},
                                          message: item
                                        }, null, 8, ["collectIds", "message"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_52))
                        ]))
                      : _createCommentVNode("", true),
                    (topList_shouc.value[2].checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          (_unref(sc_sucai_music).length > 0)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sc_sucai_music), (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      span: 12,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(moduleProvideMaterialMusic, {
                                          userList: _unref(userList),
                                          collectIds: collectIds.value,
                                          class: "cur",
                                          message: item
                                        }, null, 8, ["userList", "collectIds", "message"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("img", _hoisted_54))
                        ]))
                      : _createCommentVNode("", true),
                    (topList_shouc.value[3].checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          (_unref(sc_sucai_image).length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[15] || (_cache[15] = [
                                _createElementVNode("div", { id: "forcenter" }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("img", _hoisted_57))
                        ]))
                      : _createCommentVNode("", true),
                    (topList_shouc.value[4].checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
                              return (_openBlock(), _createBlock(moduleSEProvideMaterial, {
                                key: item.id,
                                item: item,
                                class: "SL_offerMaterialListdiv cur"
                              }, null, 8, ["item"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_el_pagination, {
                  "current-page": _unref(page).pageNum,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).pageNum) = $event)),
                  "page-size": _unref(page).pageSize,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(page).pageSize) = $event)),
                  onSizeChange: sizeChange,
                  onCurrentChange: currentChange,
                  style: {"display":"flex","justify-content":"center"},
                  background: "",
                  layout: "prev, pager, next",
                  total: _unref(page).total
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ])
          ])
        ]),
        (windowVisitChildren.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", { class: "aLP_center_top" }, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", null, "最近访问", -1)),
                  _createElementVNode("img", {
                    onClick: openWindow,
                    src: _imports_10
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wVC_list), (index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "wVC_list",
                    key: index,
                    onClick: ($event: any) => (composer(index))
                  }, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("img", {
                        class: "wVC_list_l_userImg",
                        src: index.avatar ? index.avatar : require('@/assets/logo.png')
                      }, null, 8, _hoisted_65),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, _toDisplayString(index.memberName), 1),
                          _createElementVNode("div", _hoisted_69, _toDisplayString(index.timeTitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "wVC_list_l_T_B_rz" }, [
                            _createElementVNode("img", { src: _imports_11 }),
                            _createTextVNode(" 标识山西认证导演 ")
                          ], -1)),
                          _createElementVNode("span", _hoisted_71, _toDisplayString(index.address || "暂无具体地址"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("button", {
                        class: "wVC_list_r_gz",
                        onClick: ($event: any) => (composer(index))
                      }, " 进入主页 ", 8, _hoisted_73)
                    ])
                  ], 8, _hoisted_63))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dialog, {
          title: "更换背景",
          modelValue: modifyCover.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modifyCover).value = $event)),
          "align-center": "",
          width: "800px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_el_upload, {
                class: "avatar-uploader",
                action: upload_showImage.value,
                "show-file-list": false,
                "on-change": handleChange,
                "on-success": onSuccessImages,
                "on-remove": handleRemove
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_75, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modifyCoverUpload" }, "上传背景图", -1)),
                    (!imageUrl.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: imageUrl.value,
                          class: "avatar",
                          style: {"object-fit":"cover"}
                        }, null, 8, _hoisted_77))
                  ])
                ]),
                _: 1
              }, 8, ["action"])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"margin":"0.12rem 0 0.2rem"} }, [
              _createElementVNode("div", { style: {"color":"#86909c","收藏\r\n            text-align":"center","font-size":"0.12rem","margin-bottom":"0.02rem"} }, " 请上传格式为 JPG、JPEG、PNG 的文件。 "),
              _createElementVNode("div", { style: {"color":"#86909c","text-align":"center","font-size":"0.12rem"} }, " 文件大小不超过 5M，图片尺寸不小于 1440*370 px。 ")
            ], -1)),
            _createElementVNode("div", {
              class: "modifyCoverBnt",
              onClick: submitSaverBg
            }, "保存")
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          class: "moduleShare",
          title: "",
          modelValue: _unref(shareChecked),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(shareChecked) ? (shareChecked).value = $event : shareChecked = $event)),
          "show-close": false,
          "align-center": "",
          width: "800px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            _createVNode(moduleShare, {
              onParticularsOverNo: ParticularsOverNo,
              rwm: _unref(rwm)
            }, null, 8, ["rwm"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(DetailsOfWorks, {
          ref_key: "DetailsOfWorksRef",
          ref: DetailsOfWorksRef,
          CloseQrCode: CloseQrCode
        }, null, 512),
        _createVNode(Follow, {
          ref_key: "FollowRef",
          ref: FollowRef
        }, null, 512),
        _createVNode(Vermicelli, {
          ref_key: "VermicelliRef",
          ref: VermicelliRef
        }, null, 512),
        _createElementVNode("div", _hoisted_78, [
          _withDirectives(_createVNode(_component_ShadowMaterialyinyue, {
            ref: "ShadowMaterialyinyueRef",
            mp3url: _ctx.bovalue,
            MusicOff: _ctx.MusicOff
          }, null, 8, ["mp3url", "MusicOff"]), [
            [_vShow, _ctx.isChildVisible]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})